module.exports = __webpack_public_path__ + "img/8.e07880bc.jpg";